import React from "react";

// Soft, elegant warm-brown dotted arrow that leads into the next section.
export const Connector = () => {
  const scrollNext = () => document.getElementById("two-step")?.scrollIntoView({ behavior: "smooth" });
  return (
    <div className="bg-[#F8F5EF] pb-6 md:pb-10" data-testid="routine-connector">
      <div className="max-w-2xl mx-auto px-6 flex flex-col items-center text-center">
        <p className="text-[#6F503A] font-medium text-base md:text-lg mb-4">
          Complete the routine with targeted skin barrier protection
        </p>
        <button onClick={scrollNext} aria-label="Scroll to the two-step routine" className="group">
          <svg width="60" height="90" viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M30 4 C 12 26, 48 46, 30 72"
              stroke="#6F503A"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeDasharray="1 9"
              opacity="0.55"
            />
            <path
              d="M20 63 L30 74 L40 63"
              stroke="#6F503A"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              opacity="0.7"
              className="transition-transform duration-300 group-hover:translate-y-1"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
